export default "__VITE_ASSET__Dmn6JCeY__"